module.exports = __webpack_public_path__ + "img/logo-footer.f7418c3f.jpg";